import fanBoxMessagesAction from '../actions/fanboxMessages';
import CRUDReducer from './CRUDReducer';

const fanBoxMessagesCRUDReducer = new CRUDReducer(fanBoxMessagesAction);

export default (state, action) => fanBoxMessagesCRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/fanBoxMessages.js